import React, { FC } from 'react';
import WeekDays from '../WeekDays/WeekDays';
import { TAvailableHour } from '../WeekDays/WeekDays.type';
import {
  SWorkingHoursField,
  STimeDropdownTheme,
} from './WorkingHoursField.style';

type TWorkingHoursFieldProps = {
  /** Injected by the antd FormItem. */
  value?: TAvailableHour[];
  onChange?: (hours: TAvailableHour[]) => void;
};

/**
 * New-theme working-hours editor for onboarding. Reuses the original WeekDays
 * component (day tabs + start/end range pickers + multiple ranges per day) and
 * adapts its `setCustomFieldValue` callback to the FormItem value/onChange
 * contract; styling is overridden to the ZEST-738 auth-flow theme.
 */
const WorkingHoursField: FC<TWorkingHoursFieldProps> = ({
  value,
  onChange,
}) => (
  <SWorkingHoursField>
    <STimeDropdownTheme />
    <WeekDays
      value={value}
      setCustomFieldValue={v => onChange?.(v)}
      dropdownClassName="onb-time-dropdown"
    />
  </SWorkingHoursField>
);

export default WorkingHoursField;
